import React from 'react';

function Footer() {
  return (
    <footer id="contact">
      <p>&copy; 2025 Shishir Devkota | Built with ReactJS</p>
    </footer>
  );
}

export default Footer;
